/* eslint-disable camelcase, react-hooks/rules-of-hooks */
import { useQuery, UseQueryResult } from 'react-query';
import axios from '@utils/axios';
import { PopularBrand } from '../types';
import { useGetUserData } from './useGetUserData';

export function useGetPopularBrands(): UseQueryResult<PopularBrand[]> {
  const { data: user } = useGetUserData();
  const queryFn = async (): Promise<PopularBrand[]> => {
    const result = await axios.post<{ data: PopularBrand[] }>(
      `/api/dashboard/get-popular-brands`,
      {}
    );
    return result.data;
  };

  return useQuery<PopularBrand[], Error>(`popular-deals`, () => queryFn(), {
    enabled: !!user.isAdmin,
    onError: () => {
      // Error here just means they are not logged in.
      // console.error('Something went wrong while fetching the brand deals');
    }
  });
}
